import SvgPieChart from 'src/components/icons/24/outlined/other/chart/PieChart';
import SvgCameraOn from 'src/components/icons/24/outlined/action/camera/CameraOn';
import SvgMapPin from 'src/components/icons/24/outlined/other/location/MapPin';
import SvgUsers from 'src/components/icons/24/outlined/other/person/Users';
import SvgEditForm from 'src/components/icons/24/outlined/editor/other/EditForm';
import SvgMap from 'src/components/icons/24/outlined/other/location/Map';
import SvgRadio from 'src/components/icons/24/outlined/other/tech/Radio';
import SvgHome from 'src/components/icons/24/outlined/other/Home';
import SvgGroup1363 from 'src/components/icons/Group1363';
import SvgSettings from 'src/components/icons/24/outlined/action/main/Settings';
import SvgCrosshair from 'src/components/icons/24/outlined/other/location/Crosshair';
import SvgRotationLeft from 'src/components/icons/24/outlined/directions/rotation/RotationLeft';
import SvgUser from 'src/components/icons/24/outlined/other/person/User';
import FactoryIcon from '@mui/icons-material/Factory';
import SvgBookmark from 'src/components/icons/24/outlined/other/book/Bookmark';
import SvgInbox from 'src/components/icons/24/outlined/other/mail/Inbox';
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import DomainIcon from '@mui/icons-material/Domain';
import GroupIcon from '@mui/icons-material/Group';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import WhereToVoteIcon from '@mui/icons-material/WhereToVote';
import PrivacyTipOutlinedIcon from '@mui/icons-material/PrivacyTipOutlined';
import { Role } from 'src/Api/Enum/Role';
import { PATH_PRIVACY } from 'src/routes/paths';
// ----------------------------------------------------------------------

const ICONS = {
  view: (color: string) => <SvgPieChart color={color} />,
  category: (color: string) => <SvgBookmark color={color} />,
  camera: (color: string) => <SvgCameraOn color={color} />,
  city: (color: string) => <SvgMapPin color={color} />,
  customer: (color: string) => <SvgUsers color={color} />,
  event: (color: string) => <SvgEditForm color={color} />,
  geoLocation: (color: string) => <SvgMap color={color} />,
  headCounter: (color: string) => <SvgRadio color={color} />,
  home: (color: string) => <SvgHome color={color} />,
  industry: (color: string) => <FactoryIcon htmlColor={color} />,
  layout: (color: string) => <SvgGroup1363 color={color} />,
  location: (color: string) => <SvgMap color={color} />,
  manage: (color: string) => <SvgSettings color={color} />,
  pom: (color: string) => <SvgCrosshair color={color} />,
  sensor: (color: string) => <SvgRadio color={color} />,
  swVersion: (color: string) => <SvgRotationLeft color={color} />,
  ticketing: (color: string) => <SvgInbox color={color} />,
  tag: (color: string) => <SellOutlinedIcon />,
  user: (color: string) => <SvgUser color={color} />,
  customers: (color: string) => <DomainIcon />,
  group: (color: string) => <GroupIcon />,
  // Privacy icons
  privacy: (color: string) => <PrivacyTipOutlinedIcon htmlColor={color} />,
  legalDocs: (color: string) => <GavelOutlinedIcon htmlColor={color} />,
  qa: (color: string) => <HelpOutlineIcon htmlColor={color} />,
  contactUs: (color: string) => <MailOutlineIcon htmlColor={color} />,
  locStatus: (color: string) => <WhereToVoteIcon />
};

const navConfig = [
  {
    subheader: 'welcomePage',
    items: [
      { title: 'Welcome', path: '/dashboard/welcomePage', icon: ICONS.home },
    ]
  },
  {
    subheader: 'mapLocation',
    items: [
      { title: 'Locations', path: '/dashboard/mapLocation', icon: ICONS.geoLocation },
    ]
  },
  {
    subheader: 'customerOverview',
    items: [
      { title: 'Customers', path: '/dashboard/customerOverview', icon: ICONS.customers },
    ]
  },
  {
    subheader: 'pom',
    items: [
      { title: 'PoM', path: '/dashboard/pom', icon: ICONS.pom },
    ]
  },
  {
    subheader: 'ticketing',
    items: [
      { title: 'Ticketing', path: '/dashboard/ticketing', icon: ICONS.ticketing },
    ],
    isFeature: true
  },
  {
    subheader: 'LOCATION_STATUS',
    items: [
      { title: 'Location Status', path: '/dashboard/location-status', icon: ICONS.locStatus },
    ],
    isFeature: true
  },
  {
    subheader: 'impersonation',
    items: [],
    isFeature: true
  },

  // LEGAL INFO
  // ----------------------------------------------------------------------
  {
    subheader: 'privacy_section',
    items: [
      {
        title: 'Legal Info',
        path: PATH_PRIVACY.root,
        icon: ICONS.privacy,
        children: [
          { title: 'Documents', path: PATH_PRIVACY.legalDocs, icon: ICONS.legalDocs },
          { title: 'Q&A', path: PATH_PRIVACY.qa, icon: ICONS.qa },
          { title: 'Privacy Contact', path: PATH_PRIVACY.contactUs, icon: ICONS.contactUs },
        ],
      },
    ],
    isFeature: true,
  },

  // MANAGER
  // ----------------------------------------------------------------------
  {
    subheader: 'manage',
    items: [
      {
        title: 'manage',
        path: '/dashboard/manage',
        icon: ICONS.manage,
        children: [
          {
            title: 'location',
            path: '/dashboard/manage/location',
            icon: ICONS.geoLocation,
            children: [
              { title: 'Location', path: '/dashboard/manage/location/location', icon: ICONS.location },
              { title: 'City', path: '/dashboard/manage/location/city', icon: ICONS.city },
              { title: 'Province', path: '/dashboard/manage/location/province', icon: ICONS.city },
              { title: 'Region', path: '/dashboard/manage/location/region', icon: ICONS.city },
            ]
          },
          {
            title: 'sensor',
            path: '/dashboard/manage/sensor',
            roles: [Role.ADMIN],
            icon: ICONS.sensor,
            children: [
              { title: 'Head-Counter', path: '/dashboard/manage/sensor/head-counter', icon: ICONS.headCounter },
              { title: 'PoM', path: '/dashboard/manage/sensor/pom', icon: ICONS.pom },
              { title: 'SoftwareVersion', path: '/dashboard/manage/sensor/softwareVersion', icon: ICONS.swVersion },
              { title: 'Event', path: '/dashboard/manage/sensor/event', icon: ICONS.event },
            ]
          },
          {
            title: 'tag-category',
            path: '/dashboard/manage/tag-category',
            icon: ICONS.category,
            children: [
              { title: 'Category', path: '/dashboard/manage/tag-category/category', icon: ICONS.category },
              { title: 'Tag', path: '/dashboard/manage/tag-category/tag', icon: ICONS.tag },
            ]
          },
          {
            title: 'view',
            path: '/dashboard/manage/view',
            icon: ICONS.view,
            children: [
              { title: 'View', path: '/dashboard/manage/view/view', icon: ICONS.view },
              { title: 'DashboardLayout', path: '/dashboard/manage/view/dashboardLayout', icon: ICONS.layout },
            ]
          },
          {
            title: 'Customers',
            path: '/dashboard/manage/customers',
            icon: ICONS.customers,
            children: [
              { title: 'Customer', path: '/dashboard/manage/customers/customer', icon: ICONS.customer },
              { title: 'User', path: '/dashboard/manage/customers/user', icon: ICONS.user },
              { title: 'UserGroup', path: '/dashboard/manage/customers/usergroup', icon: ICONS.group },
              { title: 'Industry', path: '/dashboard/manage/customers/industry', icon: ICONS.industry },
            ]
          },
        ],
      },
    ],
  },
];

export default navConfig;